export default __webpack_public_path__ + "static/award-2014-9680d38085078985fd78457b4e600a16.jpg";